import { Box } from '@cp/ds/src/components/box';
import { FormField } from '@cp/ds/src/components/form';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks';
import React from 'react';

export const AutoSelection = () => {
  const theme = useTheme();
  const listItems = [
    'Заказ будет оформлен автоматически. Мы выберем наиболее подходящую няню из откликнувшихся, по цене не выше указанной',
    'Мы пришлем СМС и письмо с контактами ситтера',
    'Номер телефона ситтера станет виден также в чате YouHelp',
    'Вы можете обсудить детали заказа по телефону или в чате',
  ];

  return (
    <Box
      sx={{
        borderRadius: '12px',
        border: `1px solid ${theme.palette['gray light']}`,
        p: 1.5,
        backgroundColor: theme.palette.white,
      }}
    >
      <FormField
        fieldContainerProps={{ sx: { label: { justifyContent: 'space-between' } } }}
        label="Я не хочу выбирать"
        labelPosition="left"
        labelTypography="body bold"
        name="autoSelection"
        type="switch"
      />
      <Box sx={{ mt: 1, maxWidth: 535 }}>
        {listItems.map((i, k) => (
          <Typography component="li" key={k} sx={{ ml: 1.5 }} variant="caption">
            {i}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
